import {SODeleteRole} from '../../core/role/so-delete-role';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRole extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRole;
}